import { VegaChip } from '@globalpayments/vega-react';

interface Props {
  environmentName: string;
}

const EnvironmentLabel: React.FC<Props> = ({ environmentName }) => {
  let statusColor: React.ComponentProps<typeof VegaChip>['statusColor'] = 'bg-status-info';

  switch (environmentName.toUpperCase()) {
    case 'PROD':
      statusColor = 'bg-status-error';
      break;
    case 'INTEGRATION':
      statusColor = 'bg-accent3-primary';
      break;
    case 'STAGE':
      statusColor = 'bg-status-warning';
      break;
    case 'TEST':
      statusColor = 'bg-status-success';
      break;
    case 'DEV':
    default:
      statusColor = 'bg-status-info';
      break;
  }

  return (
    <VegaChip
      chipType="status"
      size="small"
      statusColor={statusColor}
      text={environmentName.toUpperCase()}
      variant="outlined"
    />
  );
};

export default EnvironmentLabel;
